/**
 * 写剪贴板。
 *
 * 优先用 navigator.clipboard（需要 HTTPS 或 localhost），再退到 execCommand ——
 * 线上是 https，本地局域网 IP 调试走后者。不用项目里的 clipboard.js：
 * 它要在点击时 new 一个实例绑到选择器上，按钮放在弹层里时节点关掉就销毁了，容易绑不上。
 * 口径与个人主页「复制链接」（view/user/components/UserInfo.vue）一致。
 *
 * @param {String} text
 * @returns {Promise<Boolean>} 是否复制成功
 */
export function copyText (text) {
  const value = String(text == null ? '' : text)
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(value).then(() => true).catch(() => legacyCopy(value))
  }
  return Promise.resolve(legacyCopy(value))
}

function legacyCopy (text) {
  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    // 移到视口外而不是 display:none —— 隐藏元素选不中，复制会静默失败
    textarea.style.position = 'fixed'
    textarea.style.top = '-9999px'
    textarea.setAttribute('readonly', 'readonly')
    document.body.appendChild(textarea)
    textarea.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(textarea)
    return ok
  } catch (e) {
    return false
  }
}

export default copyText
